export const countries = [
    { value: 1, label: 'United States' },
    { value: 2, label: 'Canada' },
    { value: 3, label: 'Mexico' },
    { value: 4, label: 'United Kingdom' },
    { value: 5, label: 'Australia' },
    { value: 6, label: 'Germany' },
    { value: 7, label: 'France' },
    { value: 8, label: 'Italy' },
    { value: 9, label: 'Spain' },
    { value: 10, label: 'India' },
    { value: 11, label: 'China' },
    { value: 12, label: 'Japan' },
    { value: 13, label: 'South Korea' },
    { value: 14, label: 'Brazil' },
    { value: 15, label: 'Argentina' },
    { value: 16, label: 'Russia' },
    { value: 17, label: 'South Africa' },
    { value: 18, label: 'Nigeria' },
    { value: 19, label: 'Egypt' },
    { value: 20, label: 'Saudi Arabia' },
  ];